export default __webpack_public_path__ + "static/media/icon-arrow-out.d5ac3830.svg";